import { mapGetters } from "vuex";
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
export default {
  data() {
    return {
      email: "",
      password: ""
    };
  },
  mixins: [licenceFunctions],
  computed: {
    ...mapGetters([
      "getDataPrivacy",
      "getTermsAndConditions",
      "getDetailBasic",
      "getUser"
    ]),
    userOK() {
      let check = false;
      let basic = this.getUser.basic;
      if (this.checkUserOK(basic)) {
        check = true;
      } else {
        check = false;
      }
      return check;
    }
  },
  methods: {
    checkUserOK(userBasic) {
      // HELP
      // console.log("CHECK USER OK");
      // console.log(userBasic);
      // console.log(this.getDataPrivacy);
      // console.log(this.getTermsAndConditions);
      let check = false;
      let basic = userBasic;
      if (userBasic === null) {
        check = false;
      } else if (
        this.getUser.basic.act === true &&
        this.getDataPrivacy !== null &&
        this.getDataPrivacy !== undefined &&
        this.getDataPrivacy.char.rev === basic.rdp &&
        this.getTermsAndConditions !== null &&
        this.getTermsAndConditions !== undefined &&
        this.getTermsAndConditions.char.rev === basic.rtc &&
        basic.lock === false
      ) {
        check = true;
      } else {
        check = false;
      }
      return check;
    }
  }
};
